window.EG_HELP_CENTRE_FAQ = (function () {
  function normalizeSearchText(str) {
    return (str || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getFaqSearchCorpus(btn, FAQ_SEARCH_KEYWORDS) {
    var subreason = btn.getAttribute('data-subreason') || '';
    var questionEl = btn.querySelector('.cf-faq-question-text');
    var categoryEl = btn.querySelector('.cf-faq-category-label');

    var question = questionEl ? questionEl.textContent : '';
    var category = categoryEl ? categoryEl.textContent : '';
    var keywords = FAQ_SEARCH_KEYWORDS[subreason] || [];

    return normalizeSearchText(
      question + ' ' + category + ' ' + keywords.join(' ')
    );
  }

  function buildFaqCorpusCache(form, FAQ_SEARCH_KEYWORDS) {
    if (!form) return;

    form.querySelectorAll('.cf-reason').forEach(function (btn) {
      btn.__faqCorpus = getFaqSearchCorpus(btn, FAQ_SEARCH_KEYWORDS);
    });
  }

  function faqMatchesSearch(btn, rawTerm, FAQ_SEARCH_KEYWORDS) {
    var term = normalizeSearchText(rawTerm);
    if (!term) return false;

    var corpus = btn.__faqCorpus || getFaqSearchCorpus(btn, FAQ_SEARCH_KEYWORDS);
    if (!corpus) return false;

    if (corpus.includes(term)) return true;

    var tokens = term.split(' ').filter(Boolean);
    if (!tokens.length) return false;

    return tokens.every(function (token) {
      return corpus.includes(token);
    });
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;

    var matrix = [];

    for (var i = 0; i <= b.length; i++) matrix[i] = [i];
    for (var j = 0; j <= a.length; j++) matrix[0][j] = j;

    for (var i2 = 1; i2 <= b.length; i2++) {
      for (var j2 = 1; j2 <= a.length; j2++) {
        if (b.charAt(i2 - 1) === a.charAt(j2 - 1)) {
          matrix[i2][j2] = matrix[i2 - 1][j2 - 1];
        } else {
          matrix[i2][j2] = Math.min(
            matrix[i2 - 1][j2 - 1] + 1,
            matrix[i2][j2 - 1] + 1,
            matrix[i2 - 1][j2] + 1
          );
        }
      }
    }

    return matrix[b.length][a.length];
  }

  function fuzzyIncludes(corpus, term) {
    var words = corpus.split(' ');
    var termWords = term.split(' ');

    for (var i = 0; i < termWords.length; i++) {
      var t = termWords[i];
      if (!t) continue;

      var matched = false;

      for (var j = 0; j < words.length; j++) {
        var w = words[j];

        if (Math.abs(w.length - t.length) > 2) continue;

        var dist = levenshtein(w, t);

        if (dist <= 2) {
          matched = true;
          break;
        }
      }

      if (!matched) return false;
    }

    return true;
  }

  function getFaqSearchScore(btn, rawTerm, FAQ_SEARCH_KEYWORDS) {
    var term = normalizeSearchText(rawTerm);
    if (!term) return 0;

    var subreason = btn.getAttribute('data-subreason') || '';
    var questionEl = btn.querySelector('.cf-faq-question-text');
    var categoryEl = btn.querySelector('.cf-faq-category-label');

    var question = normalizeSearchText(questionEl ? questionEl.textContent : '');
    var category = normalizeSearchText(categoryEl ? categoryEl.textContent : '');
    var keywords = (FAQ_SEARCH_KEYWORDS[subreason] || []).map(normalizeSearchText);
    var corpus = normalizeSearchText(
      question + ' ' + category + ' ' + keywords.join(' ')
    );

    if (!corpus) return 0;

    var score = 0;
    var tokens = term.split(' ').filter(Boolean);

    if (question === term) score += 1000;
    if (question.indexOf(term) !== -1) score += 700;

    keywords.forEach(function (kw) {
      if (kw === term) score += 650;
      else if (kw.indexOf(term) !== -1) score += 450;
    });

    if (category === term) score += 300;
    else if (category.indexOf(term) !== -1) score += 150;

    if (corpus.indexOf(term) !== -1) score += 200;

    tokens.forEach(function (token) {
      if (!token) return;

      if (question.indexOf(token) !== -1) score += 80;
      if (category.indexOf(token) !== -1) score += 25;

      keywords.forEach(function (kw) {
        if (kw.indexOf(token) !== -1) score += 40;
      });

      if (corpus.indexOf(token) !== -1) score += 10;
    });

    if (question && question.indexOf(term) !== -1) {
      score += Math.max(0, 40 - Math.min(question.length, 40));
    }

    if (score < 100 && fuzzyIncludes(corpus, term)) {
      score += 120;
    }

    return score;
  }

  function syncOpenPanelHeight(panel) {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }

  function syncParentMorePanelHeight(panel) {
    if (!panel) return;

    var parentMorePanel = panel.closest('.cf-faq-more-panel');
    if (!parentMorePanel || !parentMorePanel.classList.contains('is-open')) return;

    parentMorePanel.style.maxHeight = parentMorePanel.scrollHeight + 'px';
  }

  function syncParentMorePanelHeightSmooth(panel, duration) {
    if (!panel) return;

    var parentMorePanel = panel.closest('.cf-faq-more-panel');
    if (!parentMorePanel || !parentMorePanel.classList.contains('is-open')) return;

    var total = duration || 360;
    var step = 34;
    var elapsed = 0;

    function tick() {
      if (!parentMorePanel.classList.contains('is-open')) return;

      parentMorePanel.style.maxHeight = parentMorePanel.scrollHeight + 'px';
      elapsed += step;

      if (elapsed <= total) {
        setTimeout(tick, step);
      }
    }

    tick();
  }

  function openMorePanel(panel) {
    if (!panel) return;

    panel.classList.add('is-open');
    panel.style.visibility = 'visible';
    panel.style.maxHeight = panel.scrollHeight + 'px';

    requestAnimationFrame(function () {
      if (panel.classList.contains('is-open')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });

    setTimeout(function () {
      if (panel.classList.contains('is-open')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    }, 50);
  }

  function closeMorePanel(panel) {
    if (!panel) return;

    panel.style.maxHeight = panel.scrollHeight + 'px';
    panel.offsetHeight;

    panel.classList.remove('is-open');
    panel.style.maxHeight = '0px';

    function handleCloseEnd(e) {
      if (e.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', handleCloseEnd);

      if (!panel.classList.contains('is-open')) {
        panel.style.visibility = 'hidden';
      }
    }

    panel.removeEventListener('transitionend', handleCloseEnd);
    panel.addEventListener('transitionend', handleCloseEnd);
  }

  function applyFaqLimit(ctx) {
    var form = ctx.form;
    var faqSearchInput = ctx.faqSearchInput;
    var FAQ_LIMIT = ctx.FAQ_LIMIT;

    var term = faqSearchInput ? faqSearchInput.value.trim().toLowerCase() : '';

    form.querySelectorAll('.cf-faq-controls').forEach(function (el) { el.remove(); });

    form.querySelectorAll('.cf-faq-more-panel').forEach(function (panel) {
      while (panel.firstChild) {
        panel.parentNode.insertBefore(panel.firstChild, panel);
      }
      panel.remove();
    });

    form.querySelectorAll('.cf-reason').forEach(function (btn) {
      btn.style.display = '';
    });

    if (term.length > 0) {
      return;
    }

    form.querySelectorAll('.cf-subgroup:not(.cf-hidden)').forEach(function (sg) {
      var faqButtons = Array.from(sg.querySelectorAll('.cf-reason:not(.cf-hidden)'));
      if (!faqButtons.length) return;

      if (faqButtons.length <= FAQ_LIMIT) {
        return;
      }

      var extraButtons = faqButtons.slice(FAQ_LIMIT);
      var morePanel = document.createElement('div');
      morePanel.className = 'cf-faq-more-panel';

      var firstExtraBtn = extraButtons[0];
      if (firstExtraBtn) {
        sg.insertBefore(morePanel, firstExtraBtn);
      } else {
        sg.appendChild(morePanel);
      }

      extraButtons.forEach(function (btn) {
        var panel = btn.nextElementSibling;
        morePanel.appendChild(btn);

        if (panel && panel.classList.contains('cf-faq-inline')) {
          morePanel.appendChild(panel);
        }
      });

      var controls = document.createElement('div');
      controls.className = 'cf-faq-controls';
      controls.className = 'cf-faq-controls';
      controls.innerHTML =
        '<button class="cf-faq-view-more" type="button">View more</button>' +
        '<button class="cf-faq-view-less is-hidden" type="button">View less</button>';

      morePanel.insertAdjacentElement('afterend', controls);

      var btnMore = controls.querySelector('.cf-faq-view-more');
      var btnLess = controls.querySelector('.cf-faq-view-less');

      btnMore.addEventListener('click', function () {
        openMorePanel(morePanel);
        btnMore.classList.add('is-hidden');
        btnLess.classList.remove('is-hidden');
      });

      btnLess.addEventListener('click', function () {
        morePanel.querySelectorAll('.cf-reason').forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
          btn.classList.remove('is-open');

          var panel = btn.nextElementSibling;
          if (panel && panel.classList.contains('cf-faq-inline')) {
            closeFaqPanel(panel);
          }
        });

        closeMorePanel(morePanel);
        btnMore.classList.remove('is-hidden');
        btnLess.classList.add('is-hidden');
      });
    });
  }

function openFaqPanel(panel) {
  if (!panel) return;

  window.EG_HELP_CENTRE_ACCORDION.open(panel);

  requestAnimationFrame(function () {
    syncParentMorePanelHeight(panel);
    syncParentMorePanelHeightSmooth(panel, 360);
  });

  setTimeout(function () {
    syncParentMorePanelHeight(panel);
  }, 50);
}
  
  function closeFaqPanel(panel) {
    if (!panel) return;

    window.EG_HELP_CENTRE_ACCORDION.close(panel);

    syncParentMorePanelHeight(panel);
    syncParentMorePanelHeightSmooth(panel, 360);
  }
  
  function resetFaqHighlight(ctx) {
    if (ctx.highlightedFaqBtn) {
      ctx.highlightedFaqBtn.classList.remove('cf-faq-highlight');
      ctx.highlightedFaqBtn = null;
    }
    if (ctx.highlightedFaqPanel) {
      ctx.highlightedFaqPanel.classList.remove('cf-faq-highlight-panel');
      ctx.highlightedFaqPanel = null;
    }
  }

  function resetAllFaqPanels(ctx) {
    ctx.form.querySelectorAll('.cf-reason').forEach(function (faqBtn) {
      faqBtn.setAttribute('aria-expanded', 'false');
      faqBtn.classList.remove('is-open');
    });

    ctx.form.querySelectorAll('.cf-faq-inline').forEach(function (panel) {
      panel.classList.remove('cf-faq-highlight-panel');
      closeFaqPanel(panel);
    });

    resetFaqHighlight(ctx);
  }

  function resetFaqToDefaultState(ctx) {
    resetAllFaqPanels(ctx);

    ctx.form.querySelectorAll('.cf-reason').forEach(function (btn) {
      btn.classList.remove('cf-hidden');
      btn.classList.remove('cf-hidden');
    });

    var trigger = document.getElementById('faqContactTrigger');
    if (trigger) {
      trigger.classList.remove('is-hidden');
    }

    ctx.form.querySelectorAll('.cf-faq-controls').forEach(function (ctrl) {
      ctrl.remove();
    });
  }

  function toggleFaq(ctx, btn, subreason, forceOpen, highlight) {
    var faqContent = ctx.faqContent;

    var dataKey = subreason || btn.getAttribute('data-subreason') || null;
    if (!dataKey || !faqContent[dataKey]) return;

    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    var shouldOpen = (typeof forceOpen === 'boolean') ? forceOpen : !isOpen;

    var panel = btn.nextElementSibling;
    if (!panel || !panel.classList.contains('cf-faq-inline')) {
      panel = document.createElement('div');
      panel.className = 'cf-faq-inline';
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-hidden', 'true');

      var panelId = 'faq-panel-' + (btn.getAttribute('data-subreason') || Math.random().toString(36).slice(2));
      panel.id = panelId;
      btn.setAttribute('aria-controls', panelId);

      btn.insertAdjacentElement('afterend', panel);
    }

    if (!shouldOpen) {
      btn.setAttribute('aria-expanded', 'false');
      btn.classList.remove('is-open');
      closeFaqPanel(panel);
      panel.setAttribute('aria-hidden', 'true');

      if (btn === ctx.highlightedFaqBtn) {
        btn.classList.remove('cf-faq-highlight');
        if (ctx.highlightedFaqPanel === panel) {
          panel.classList.remove('cf-faq-highlight-panel');
          ctx.highlightedFaqPanel = null;
        }
        ctx.highlightedFaqBtn = null;
      }
      return;
    }

    var form = btn.closest('form');
    if (form) {
      form.querySelectorAll('.cf-reason').forEach(function (otherBtn) {
        if (otherBtn === btn) return;

        otherBtn.setAttribute('aria-expanded', 'false');
        otherBtn.classList.remove('is-open');

        var otherPanel = otherBtn.nextElementSibling;
        if (otherPanel && otherPanel.classList.contains('cf-faq-inline')) {
          closeFaqPanel(otherPanel);
        }

        if (otherBtn === ctx.highlightedFaqBtn) {
          otherBtn.classList.remove('cf-faq-highlight');

          if (ctx.highlightedFaqPanel === otherPanel) {
            otherPanel.classList.remove('cf-faq-highlight-panel');
            ctx.highlightedFaqPanel = null;
          }

          ctx.highlightedFaqBtn = null;
        }
      });
    }

    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    panel.innerHTML =
      faqContent[dataKey] +
      '<div class="cf-faq-helpful">' +
        '<p class="cf-faq-helpful__text">Did this answer your question?</p>' +
        '<div class="cf-faq-helpful__actions">' +
          '<button type="button" class="cf-faq-helpful__btn cf-faq-helpful__btn--yes">Yes</button>' +
          '<button type="button" class="cf-faq-helpful__btn cf-faq-helpful__btn--no" data-action="show-related-help">No, show related help</button>' +
        '</div>' +
      '</div>';
    openFaqPanel(panel);

    if (highlight) {
      btn.classList.add('cf-faq-highlight');
      panel.classList.add('cf-faq-highlight-panel');
      ctx.highlightedFaqBtn = btn;
      ctx.highlightedFaqPanel = panel;
    }
  }

  window.addEventListener('resize', function () {
    document.querySelectorAll('.cf-faq-inline.is-open').forEach(function (panel) {
      window.EG_HELP_CENTRE_ACCORDION.sync(panel);
      syncParentMorePanelHeight(panel);
    });
  });

  return {
    normalizeSearchText: normalizeSearchText,
    getFaqSearchCorpus: getFaqSearchCorpus,
    buildFaqCorpusCache: buildFaqCorpusCache,
    faqMatchesSearch: faqMatchesSearch,
    levenshtein: levenshtein,
    fuzzyIncludes: fuzzyIncludes,
    getFaqSearchScore: getFaqSearchScore,
    applyFaqLimit: applyFaqLimit,
    resetFaqHighlight: resetFaqHighlight,
    resetAllFaqPanels: resetAllFaqPanels,
    resetFaqToDefaultState: resetFaqToDefaultState,
    toggleFaq: toggleFaq
  };
})();